import BackendModel from 'ln/model/BackendModel';
// import { mapper } from 'ln/model/Mapper';
import { backend } from '../../setup';

class UserFileModel extends BackendModel {

	constructor( json:Object ){
		super( json );	
	}

	get id():number {
		return this.get<number>( 'id' );
	}
	
	get name():string {
		return this.get<string>( 'name' );
	}

	get file_name():string {
		return this.get<string>( 'file_name' );
	}

	get modelName():string{
		return this.get<string>( 'modelName' );	
	}
}

export default UserFileModel;

backend.mapper.toModel.add( 'App\\UserFile', function( json:Object ){
	return new UserFileModel( json );
});

backend.mapper.toJson.add( 'App\\UserFile', function( model:UserFileModel ) {
	return model.object();
});